import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '~/store/composable';
import { computed } from '@nuxtjs/composition-api';
import { getItemGyriId } from '~/utils/userItem';
import MysteryBoxExchangeDialog from '~/components/Collections/MysteryBoxExchangeDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsMysteryBoxModal',
  setup(__props) {

const { state, dispatch } = useStore();

const showRewardMysteryBoxModal = computed(
  () => state?.rewards?.showRewardMysteryBoxModal ?? false,
);

const currentRewardGyriId = computed(
  () => state?.rewards?.currentReward?.gyriId,
);

const currentRewardGyriItem = computed(() => {
  return state?.inventory?.userItems?.find(
    (item) => getItemGyriId(item) === currentRewardGyriId.value,
  );
});

const showModal = computed(() => {
  return (
    showRewardMysteryBoxModal.value && currentRewardGyriItem.value !== undefined
  );
});

function closed() {
  dispatch('rewards/showRewardMysteryBoxModal', false);
}

return { __sfc: true,state, dispatch, showRewardMysteryBoxModal, currentRewardGyriId, currentRewardGyriItem, showModal, closed, MysteryBoxExchangeDialog }
}

})